import React from 'react';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import {
  createContainer,
  VictoryArea,
  VictoryAxis,
  VictoryBar,
  VictoryChart,
  VictoryGroup,
  VictoryLine,
  VictoryStack,
} from 'victory';
import { zoomButton } from '../../utils/helpers/view/ecpDetailHelper';
import {
  PluvioAxis,
  YAxis,
} from '../../utils/helpers/view/chartsComponentHelper';
import { v4 as uuidv4 } from 'uuid';

interface EcpChartsComponentProps {
  display: string;
  height: string;
  sanitaryWater: any[];
  mode: string;
  title: string;
  colorsLegend: string[];
  pluvioData: any[];
  piezoData?: any[];
  pluvioMax: number;
  piezoMax?: number;
  dataMaxValue: number;
  axisYLabel: string;
  axisXLabel: string;
  axisYLabelPluvio: string;
  handleZoomIn(): void;
  handleZoomOut(): void;
  dataSelected?: any;
}

const EcpChartsComponent = (props: EcpChartsComponentProps) => {
  const VictoryZoomVoronoiContainer = createContainer('zoom', 'voronoi') as React.ComponentType<any>;
  const graphicSize = {
    width: 900,
    height: 400,
  };
  const controlData = (props.sanitaryWater !== null && props.sanitaryWater.length > 0) || (props.pluvioData !== null && props.pluvioData.length > 0) || (props.piezoData !== undefined && props.piezoData !== null && props.piezoData!.length > 0);
  
  return (
    <>
      <div
        style={{
          display: props.display,
          height: props.height,
          borderRadius: '15px',
          boxShadow: '0 14px 14px 3px rgba(18, 26, 49, 0.05)',
          backgroundColor: 'white',
          marginBottom: '15px',
        }}
      >
        {controlData &&  
          <div
            style={{
              position: 'absolute',
              zIndex: 1,
            }}
          >
            {zoomButton(props)}
          </div>}
        <div
          style={{ textAlign: 'center', fontSize: '16px', paddingTop: '15px' }}
        >
          <Word value={props.title} variant='span' textStyle='normalBold' />
        </div>
        {controlData ? (
          <VictoryChart
            domainPadding={props.mode === 'bar' ? { x: 20 } : {}}
            height={graphicSize.height}
            width={graphicSize.width}
            scale={{ x: 'time' }}
            style={{
              parent: {
                bottom: 30,
              },
            }}
            containerComponent={
              <VictoryZoomVoronoiContainer
                labels={(datum) => {
                  if (datum.datum.type) {
                    const type = datum.datum.type ? `${datum.datum.type} - ` : '';
                    const date = new Date(datum.datum.x).toLocaleDateString('fr');
                    return `${type}${datum.datum.y} - ${date}`;
                  } else {
                    return '';
                  }     
                }}
              />
            }
          >
            {props.mode === 'area' ? (
              <VictoryGroup>
                {props.sanitaryWater !== null && props.sanitaryWater.length > 0 && (
                  <VictoryStack height={graphicSize.height} width={graphicSize.width}>
                    {props.sanitaryWater.map((line, index) => {                      
                      return (
                        <VictoryArea
                          key={uuidv4()}
                          style={{
                            data: {
                              fill: props.colorsLegend[index],
                            },
                          }}
                          data={line}
                          x='x'
                          y='y'
                        />
                      );
                    })}
                  </VictoryStack>
                )}
                {props.dataSelected.id === 1 && props.pluvioData.length > 0 && ( 
                <VictoryStack>
                  <VictoryLine
                    style={{
                      data: { stroke: '#63D1B5', strokeWidth: 3 },
                    }}
                    data={props.pluvioData}
                    x='x'
                    y={(datum) => {
                      if (props.pluvioMax === null || props.pluvioMax === 0) {
                        return datum.y;
                      } else if (
                        props.dataMaxValue === null ||
                        props.dataMaxValue === 0
                      ) {
                        return datum.y;
                      } else {
                        return (
                          (datum.y / props.pluvioMax) * props.dataMaxValue
                        );
                      }
                    }}
                    height={graphicSize.height}
                    width={graphicSize.width}
                  />
                </VictoryStack>)}
                {props.dataSelected.id === 2 && props.piezoData !== null && props.piezoData!.length > 0 && ( 
                <VictoryStack>
                  <VictoryLine
                    style={{
                      data: { stroke: '#9400D3', strokeWidth: 3 },
                    }}
                    data={props.piezoData}
                    x='x'
                    y={(datum) => {
                      if (props.piezoMax === null || props.piezoMax === 0) {
                        return datum.y;
                      } else if (
                        props.dataMaxValue === null ||
                        props.dataMaxValue === 0
                      ) {
                        return datum.y;
                      } else {
                        return (
                          (datum.y / props.piezoMax!) * props.dataMaxValue
                        );
                      }
                    }}
                    height={graphicSize.height}
                    width={graphicSize.width}
                  />
                </VictoryStack>)}
              </VictoryGroup>
            ) : (
              <VictoryGroup offset={16} standalone={false}>
                {props.sanitaryWater !== null && props.sanitaryWater.length > 0 && (
                  <VictoryStack>
                    {props.sanitaryWater.map((bar, index: number) => {
                      return (
                        <VictoryBar
                          key={uuidv4()}
                          data={bar}
                          barWidth={12}
                          x='x'
                          y='y'
                          style={{
                            data: {
                              fill: props.colorsLegend[index],
                            },
                            labels: {
                              color: 'red',
                            },
                          }}
                        />
                      );
                    })}
                  </VictoryStack>
                )}
                {props.pluvioData !== null && props.pluvioData.length > 0 && (
                  <VictoryStack>
                    <VictoryBar
                      data={props.pluvioData}
                      x='x'
                      barWidth={12}
                      y={(datum) => {
                        if (props.pluvioMax === null || props.pluvioMax === 0) {
                          return datum.y;
                        } else if (
                          props.dataMaxValue === null ||
                          props.dataMaxValue === 0
                        ) {
                          return datum.y;
                        } else {
                          return (
                            (datum.y / props.pluvioMax) * props.dataMaxValue
                          );
                        }
                      }}
                      style={{
                        data: { fill: '#63D1B5' },
                      }}
                    />
                </VictoryStack>)}
              </VictoryGroup>
            )}
            {/* y axis */}
            {props.sanitaryWater !== null && props.sanitaryWater.length > 0 && YAxis(props, 10)}
            {/* x axis */}
            {
              <VictoryAxis
                standalone={false}
                label={props.axisXLabel}
                tickCount={props.mode === 'bar' ? 12 : 6}
                style={{
                  axis: {
                    strokeWidth: 1,
                  },
                  axisLabel: {
                    padding: 30,
                    fontSize: 9,
                  },
                  ticks: { stroke: 'grey', size: 4 },
                  tickLabels: {
                    fontSize: 9,
                  },
                }}
                tickFormat={(date) => {
                  return date
                    .toLocaleString('default', {
                      day: 'numeric',
                      month: 'short',
                    })
                    .concat(
                      '\n' +
                        date.toLocaleString('default', {
                          hour: 'numeric',
                        })
                    );
                }}
              />
            }
            {/* pluvio/piezo axe */}
            {props.dataSelected.id !== 3 && PluvioAxis(props, 850, props.dataSelected.id === 1 ? props.pluvioMax : props.piezoMax!, '10')}
          </VictoryChart>
        ) : (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '35vh',
            }}
          >
            <span style={{ color: 'red', fontSize: '14px' }}>Aucune données !</span>
          </div>
        )}
      </div>
    </>
  );
};

export default React.memo(EcpChartsComponent);
